import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { initThemeOnBoot } from './lib/theme';
import { AuthProvider } from './lib/auth';
import App from './App.jsx';

import './styles/tokens.css';
import './styles/mobile.css';

// Apply theme before React mounts to avoid flash-of-wrong-theme
initThemeOnBoot();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
